<template>
  <div class="sign-print">
    <div class="sign_print_item">
      <header>票凭证</header>
      <Form v-if="infoData" :label-width="80">
        <FormItem label="场馆:">
          <div>{{ infoData.bus_name }}</div>
        </FormItem>
        <FormItem label="票名称:">
          <div>{{ infoData.san_name }}</div>
        </FormItem>
        <FormItem label="有效时间:">
          <div>{{ infoData.validity_date }}</div>
          <div>{{ infoData.validity_time }}</div>
        </FormItem>
        <FormItem label="适用场地:">
          <div>{{ spaceNames }}</div>
        </FormItem>
        <FormItem label="核销时间:">
          <div>{{ infoData.sign_in_time_string }}</div>
        </FormItem>

        <div class="line"></div>

        <div class="qrcode-box">
          <div class="number">{{  consumeSn }}</div>
          <img class="qrcode" :src="infoData.qrcode_url" alt="二维码" />
        </div>

        <!-- <FormItem label="基础费:" class="space-bet-row w-48">
          <div>{{ infoData.base_fee }}</div>
        </FormItem>
        <FormItem label="超时费:" class="space-bet-row w-48">
          <div>{{ infoData.over_fee }}</div>
        </FormItem>

        <div class="line"></div>

        <FormItem label="总计:" class="space-bet-row w-48">
          <div>{{ infoData.total_fee }}</div>
        </FormItem>
        <FormItem label="支付方式:" class="space-bet-row w-48">
          <div>{{ infoData.pay_type }}</div>
        </FormItem>

        <div class="line"></div>

        <FormItem label="打印时间:">
          <div>{{ infoData.print_time }}</div>
        </FormItem>
        <FormItem label="打印账号:">
          <div>{{ infoData.print_account }}</div>
        </FormItem> -->
      </Form>
    </div>
  </div>
</template>

<script>
  import { formatDate } from '@/utils/index'

  export default {
    name: 'nonMemberPrint',
    data () {
      return {
        logId: 1,
        infoData: {},
        spaceNames: '',
        consumeSn: ''
      }
    },
    created () {
        this.logId = this.$route.query.logId;
        this.getInfo();
    },
    methods: {
      getInfo () {
        return this.$service.get(`/Web/San/getSmallTicket?san_log_id=${this.logId}`).then(res => {
            if (res.data.errorcode == 0) {
                this.infoData = res.data.data;
                this.infoData.sign_in_time_string = formatDate(new Date(Number(this.infoData.sign_in_time)*1000), 'yyyy-MM-dd')
                if (Array.isArray(this.infoData.can_use_space_ids_copy)) {
                  const names = this.infoData.can_use_space_ids_copy.join(',')
                  this.spaceNames = names?names:'入场'
                } else {
                  this.spaceNames = '入场'
                }
                const sn = this.infoData.consume_sn
                this.consumeSn = `${sn.substring(0, 4)}  ${sn.substring(4, 8)}  ${sn.substring(8, 12)}`
                this.$nextTick(() => {
                  window.addEventListener('afterprint', (event) => {
                    localStorage.setItem('receipt',true)
                    window.close();
                  });
                  setTimeout(() => {
                    window.print();
                  }, 500);
                });
            } else {this.$Message.error(res.data.errormsg);}
        });
      }
    }
  }
</script>

<style lang="less" scoped>
.remark {
  margin: 0 0 15pt;
}
.space-bet-row:before {
   content: none;
}
.space-bet-row:after {
   content: none;
}
@media print {
  -webkit-print-color-adjust: exact;
  * {
    margin: 0;
    padding: 0;
    line-height: 1;
  }
  @page {
    size: 48mm auto;
    margin: 0;
    padding: 0;
  }
}
.w-48 {
  width: 48mm
}
.length-lim-48 {
  width: 48mm;
  word-break: break-all;
  line-height: 1;
}

// ::v-deep .ivu-form-item {
//   display: block !important;
// }

/deep/ .ivu-form-item {
  display: block !important;
}

// ::v-deep .ivu-form-item-label {
//   line-height: 32px;
// }

/deep/ .ivu-form-item-label {
  line-height: 32px;
}

.qrcode-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .number {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    width: 100%;
    text-align: center;
  }

  .qrcode {
    width: 200px;
    height: 200px;
  }
}
</style>